import React, { useEffect } from "react";
import RepoStats from "./components/RepoStats";
import Navbar from "./components/Navbar";
import Linkbar from "./components/Linkbar";
import Intro from "./components/Intro";
import About from "./components/About";
import Education from "./components/Education";
import WorkExperience from "./components/WorkExperience";
import Trading from "./components/Trading";
import SideProjects from "./components/SideProjects";
import Footer from "./components/Footer";
import ResumePage from "./components/Resume";
import Error404 from "./components/Error404";
import Coaching from "./components/Coaching";

import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

import "./styles/style.css";
import content from "./content.json";

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    

    const id = hash.replace("#", "");
    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return true;
      }
      return false;
    };

    if (scrollToTarget()) {
      return;
    }

    const timeoutId = setTimeout(scrollToTarget, 150);
    return () => clearTimeout(timeoutId);
  }, [pathname, hash]);

  return null;
}

// Note that the section.enable_section has to equal true in
// order for that specific component to load in the app.js

function App() {
  const { intro_screen, about_me, academics, experience, trading, projects } = content;

  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Navbar />
              <RepoStats />
              <Linkbar />
              {intro_screen.section.enable_section && <Intro />}
              {about_me.section.enable_section && <About />}
              {academics.section.enable_section && <Education />}
              {experience.section.enable_section && <WorkExperience />}
              {trading.section.enable_section && <Trading />}
              {projects.section.enable_section && <SideProjects />}
              <Footer />
            </div>
          }
        ></Route>
        <Route path="/resume" element={<ResumePage />} />
        <Route path="/coaching" element={<div><Navbar /><Coaching /><Footer /></div>} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
